import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import mainStyles from "../../../services/styles";

const LicensesCollapsibleHeader = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div css={mainStyles.collapsibleTableHeaderContainer}>
      <div css={mainStyles.collapsibleTableHeaderFirstCell}>
        {t(`ProjectsPage##licensingSection##License`)}
      </div>
      <div css={mainStyles.collapsibleTableHeaderFirstCell}>
        {t(`ProjectsPage##licensingSection##LicenseType`)}
      </div>
      <div css={mainStyles.collapsibleTableHeaderCell}>
        {t(`ProjectsPage##licensingSection##MediaType`)}
      </div>
      <div css={mainStyles.collapsibleTableHeaderCell}>
        {t("ProjectsPage##licensingSection##TracksColumn")}
      </div>
      <div css={mainStyles.collapsibleTableHeaderCell}>
        {t("ProjectsPage##licensingSection##Territories")}
      </div>
      <div css={mainStyles.collapsibleTableHeaderCell}>
        {t("ProjectsPage##licensingSection##Duration")}
      </div>
      <div css={mainStyles.summaryIconContainer} />
    </div>
  );
};

export default LicensesCollapsibleHeader;
